import { Statistic } from 'antd';
import { Button, Input, Message } from '@bluevision/components';
import styles from './style.less';
import { useRequest } from 'ahooks';
import { getCaptcha } from '@/services/authority/login';
import type { FormInstance } from 'antd/es/form/Form';
import { useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import type { UserAPI } from '@/services/authority/interface';
import type { CaptchaParams } from '@/hooks/useCaptcha';
import useCaptcha from '@/hooks/useCaptcha';

const { Countdown } = Statistic;

interface FormItemProps {
  value?: string;
  onChange?: (checked: string) => void;
  form: FormInstance;

  verify_type: UserAPI.Common.SmsCodeType; // 验证码类型
  dependency: string; // 依赖字段
  className?: string;
}

const SmsCodeFormItem: React.FC<FormItemProps> = ({
  form,
  value,
  onChange,
  verify_type,
  dependency,
  className,
}) => {
  const { t } = useTranslation();
  // 获取验证码倒计时
  const [isCountDown, setIsCountDown] = useState(false);

  const { loading, runAsync } = useRequest(getCaptcha, { manual: true });

  const captcha = async (capchaParmams: CaptchaParams) => {
    try {
      const [, error] = await runAsync({
        phone: form.getFieldValue(dependency),
        verify_type,
        ...capchaParmams,
      });

      if (!error) {
        Message.success(error ?? t('the_verification_code_has_been_sent_please_check_it'));
        setIsCountDown(true);
      }
    } catch (e) {}
  };
  // 引入验证码，传递回调（手机号验证码场景）
  const { captchaInit } = useCaptcha({
    callFn: (capchaParmams) => {
      captcha(capchaParmams);
    },
    userEmail: form.getFieldValue(dependency), // 获取用户输入的手机号作为邮箱字段
  });
  const getSliderCaptcha = async () => {
    form.validateFields([dependency]).then(() => {
      // 引入腾讯滑块验证码
      captchaInit();
    });
  };

  return (
    <div className={classNames(styles['sms-code-content'], className)}>
      <Input
        size='large'
        placeholder={t('please_enter_the_verification_code')}
        suffix={
          <Button
            type='primary'
            onClick={getSliderCaptcha}
            loading={loading}
            disabled={isCountDown}
            className={classNames('fx-v-c', styles['sms-code-btn'])}
          >
            {isCountDown ? (
              <Countdown
                format='ss'
                value={Date.now() + 60 * 1000}
                onFinish={() => setIsCountDown(false)}
                valueStyle={{ fontSize: 14, color: '#fff' }}
                suffix={`s ${t('resend')}`}
              />
            ) : (
              t('get_verification_code')
            )}
          </Button>
        }
        onChange={(e) => {
          onChange?.(e.target.value);
        }}
        value={value}
      />
    </div>
  );
};

export default SmsCodeFormItem;
